import { MIN_PERCENTAGE_DISPLAY } from '../constants';
function calculateDifferences(percentage) {
  if (percentage < MIN_PERCENTAGE_DISPLAY && percentage > 0) {
    return MIN_PERCENTAGE_DISPLAY - percentage;
  }
  return 0;
}

/**
 * From https://git.hubteam.com/HubSpot/ContentEmailUI/blob/master/static/js/components/details/performance/PerformanceTimeSpentViewingChart.js#L50-L74
 */
export function getMinPercentageDifference(readPercentage, skimmedPercentage, glancedPercentage) {
  const readDiff = calculateDifferences(readPercentage);
  const skimmedDiff = calculateDifferences(skimmedPercentage);
  const glancedDiff = calculateDifferences(glancedPercentage);
  const diffSum = readDiff + skimmedDiff + glancedDiff;
  let numberOfMinPercentages = 0;
  if (readDiff === 0 && readPercentage - diffSum > MIN_PERCENTAGE_DISPLAY) {
    numberOfMinPercentages++;
  }
  if (skimmedDiff === 0 && skimmedPercentage - diffSum > MIN_PERCENTAGE_DISPLAY) {
    numberOfMinPercentages++;
  }
  if (glancedDiff === 0 && glancedDiff - diffSum > MIN_PERCENTAGE_DISPLAY) {
    numberOfMinPercentages++;
  }
  return numberOfMinPercentages > 0 ? diffSum / numberOfMinPercentages : 0;
}
export function getNormalizedViewingPercentage(viewingPercentage, percentageDifference) {
  let normalizedViewingPercentage = viewingPercentage - percentageDifference;
  if (viewingPercentage < MIN_PERCENTAGE_DISPLAY) {
    normalizedViewingPercentage = MIN_PERCENTAGE_DISPLAY;
  } else if (viewingPercentage - percentageDifference < MIN_PERCENTAGE_DISPLAY) {
    normalizedViewingPercentage = viewingPercentage;
  }
  return normalizedViewingPercentage;
}